import { kearnyConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function KearnyPage() {
  return <CityPageTemplate config={kearnyConfig} />;
}